<template>
  <!--<div class="bg">-->
    <div class="container">
      <!--<div class="content">-->
        <div class="position">
          <p>{{location}}</p>
        </div>
        <div>
          <p class="desc">{{detail}}</p>
        </div>
        <!-- <div class="map">
          <img :src="mapurl" />
        </div> -->
      <!--</div>-->
    </div>
  <!--</div>-->
</template>

<script>
  export default {
    props: ['location', 'detail', 'mapurl'],
    name: 'homeContactContent'
  }
</script>

<style scoped>
  div.bg {
    display: flex;
  }

  div.container {
    float: left;
    padding-top: 40px;
    width: 50%;
    padding-left: 0;
    padding-right: 0;
    height: auto;
    margin: auto;
    background-color: rgb(255, 255, 255);
  }

  div.content {

    margin: auto;
    margin-top: 3%;
    margin-bottom: 3%;
  }

  div.position {
    color: rgb(73, 73, 73);
    font-family: PingFangSC-Semibold, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    text-align: left;
  }

  .desc {
    color: rgb(73, 73, 73);
    font-size: 16px;
    padding-top: 25px;
    padding-bottom: 25px;
    line-height: 50px;
  }

  p {
    text-align: left;
    white-space: pre;
    padding: 0;
    margin: 0;
  }

  img {
    width: 100%;
    height: 100%;
  }
  .map {
    height: auto;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// HomeContactContent.vue?1c0dc4bc